import { Share } from 'lucide-react';
import { isIOS, isStandaloneMode } from '@/lib/push';

export function IOSPushHint() {
  if (!isIOS() || isStandaloneMode()) return null;

  return (
    <div className="mx-4 mb-4 p-3 bg-blue-50 border border-blue-200 rounded-xl flex gap-3 items-start text-sm">
      <Share className="w-4 h-4 text-blue-600 mt-0.5 shrink-0" />
      <p className="text-blue-800">
        <strong>iPhone tip:</strong> Tap the Share button then "Add to Home Screen" to enable push notifications on iOS.
      </p>
    </div>
  );
}
